import { CommonDependency } from '@/dependency';
import { useMutation } from 'react-query';

export const useCommonImageUpload = (category: 'feed', size?: number) => {
  const mutation = useMutation(
    (
      file: any,
      params?: {
        height?: number;
        width?: number;
      },
    ) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('category', category);
      if (size) {
        formData.append('size', String(size));
      }
      if (params?.height) {
        formData.append('height', String(params?.height));
      }
      if (params?.width) {
        formData.append('width', String(params?.width));
      }

      return CommonDependency.api.postUploadImage(formData);

      // return request.post<{
      //   image: {
      //     id: string;
      //     raw: {
      //       oss_url: string;
      //       full_url: string;
      //     };
      //     resize: {
      //       oss_url: string;
      //       full_url: string;
      //     };
      //   };
      // }>('/common/upload_image_v2', formData, {
      //   // override default headers(content-type)
      //   // let browser add it's own content-type with boundary
      //   headers: {},
      //   timeout: Infinity,
      // });
    },
  );

  return mutation;
};
